import { cn } from '@/lib/utils';

export type StatusLineProps = {
  text: string;
  /** Pulses while the step is in progress; settles into a quiet record once it finishes. */
  isActive?: boolean;
  className?: string;
};

/** One line of assistant activity: waiting, or a tool step in the timeline. */
export function StatusLine({ text, isActive = true, className }: StatusLineProps) {
  return (
    <p
      role={isActive ? 'status' : undefined}
      className={cn('py-1 text-sm font-normal text-muted-foreground', className)}
    >
      <span className={cn(isActive && 'motion-safe:animate-status-pulse')}>{text}</span>
    </p>
  );
}
